import { Component, HostListener, inject, Input, OnDestroy } from '@angular/core';
import { Configuration } from 'src/app/models/configurators-2d/applications/fence/configuration';
import { FenceService } from 'src/app/services/configurators-2d/applications/fence.service';
import { PreviewItem } from '../../configurator/previews/preview-item';
import { FencePreviewFacadeService } from './services/fence-preview.facade.service';
import { FencePreviewItem } from './models/fence-preview-item';

@Component({
  selector: 'ng-fence-preview',
  templateUrl: './preview.component.html',
})
export class FencePreviewComponent extends PreviewItem<Configuration, FenceService> implements OnDestroy {
  @Input() step: number;

  /** Objet prévisualisation - copie locale pour éviter les réévaluations */
  items: FencePreviewItem[] = [];

  protected readonly fencePreviewFacadeService = inject(FencePreviewFacadeService);

  constructor(service: FenceService) {
    super(service);
  }

  @HostListener('window:resize')
  async onResize() {
    switch (this.step) {
      case 4:
      case 3:
        await this.constructPreview();
        break;
      case 5:
        await this.constructResumeGroups();
        break;
    }
  }

  ngOnDestroy(): void {
    this.fencePreviewFacadeService.reset();
  }

  async update(): Promise<void> { }

  async constructPreview(): Promise<void> {
    await this.fencePreviewFacadeService.constructPreview();
  }

  /**
   * Construction des groupes à afficher dans le récap
   * @private
   */
  async constructResumeGroups(): Promise<void> {
    this.fencePreviewFacadeService.setDifferentHeights();
    await this.fencePreviewFacadeService.constructResumeGroups();
  }
}
